<select class="form-control state-list" (change)="onStateChange($event.target.value)" [(ngModel)]="value">
  <option value="" disabled>Choose a state</option>
  <option *ngFor='let state of stateList' [value]="state.abbreviation">{{state.name}}</option>
</select>
